<template>
  <div>
    <h2 class="font-weight-bold pb-5">Tambah Dropship</h2>
    <!-- <div class="d-block text-subtitle-2 pb-3">
      Pastikan produk Anda sudah sesuai dengan syarat dan ketentuan HWI Ecommerce. 
      HWI Ecommerce menghimbau seller untuk menjual produk dengan harga yang wajar atau produk Anda dapat diturunkan oleh HWI Ecommerce sesuai S&K yang berlaku.
    </div> -->
    <v-form ref="formAddDropship" role="form">
      <v-card outlined class="px-3">
        <v-card-text class="px-2">
        <v-row>
            <v-col cols="12" sm="7" class="">
              <v-autocomplete
                v-model="dropshipInput"
                :items="listDropship"
                :rules="dropshipRules"
                placeholder="Pilih Dropship"
                hide-details="auto"
                outlined
                dense
                :error-messages="responseError.store_id"
                @focus="() => responseError.store_id=''"
                @change="getStorePartnerships()"
              >
                <!-- <template v-if="listDropship.length > 0"> -->
                  <template v-slot:selection="{ item }">
                    <span class="text-capitalize" v-if="listDropship.length > 0">{{ item.store_name }} - {{item.store_city_name}}</span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span class="text-capitalize" v-if="listDropship.length > 0">{{ item.store_name }} - {{item.store_city_name}}</span>
                  </template>
                <!-- </template> -->
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="5" class="text-right ">
              <v-btn
                color="error"
                elevation="0"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                class="mr-2"
                v-if="!isMobile"
                @click="cancelForm"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>

              <v-btn
                color="success"
                elevation="0"
                min-width="140"
                :loading="loadingProcess"
                :class="(isMobile) ? 'v-btn--block mb-3' : ''"
                @click="save(2)"
                :disabled="(Object.keys(dropshipInput).length > 1) ? false : true"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Tambah</strong>
              </v-btn>

              <v-btn
                color="success"
                elevation="2"
                outlined
                dark
                :class="(isMobile) ? 'v-btn--block mb-3' : 'mr-2'"
                min-width="140"
                :loading="loadingProcess"
                :disabled="(Object.keys(dropshipInput).length > 1) ? false : true"
                @click="save(1)"
                v-if="isMobile"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Tambah</strong>
              </v-btn>

              <v-btn
                color="error"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="(isMobile) ? 'v-btn--block mb-3' : 'mr-2'"
                v-if="isMobile"
                @click="cancelForm"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="hwi-border mt-3" v-if="Object.keys(dropshipInput).length > 1">
        <v-row class="px-3">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="2" sm="2" md="23" class="py-0 pr-0 my-auto" >
                <v-img width="100%" class="border" :src="dropshipInput.store_image ? dropshipInput.store_image : '/assets/seller/default-toko.jpg'"></v-img>
              </v-col>
              <v-col cols="10" sm="10" md="10" class="py-0 pl-5">
                <div class="text-uppercase primary--text font-weight-bold text-subtitle-2">
                  {{dropshipInput.store_name}}
                </div>
                <div class="pt-1 text-caption text-body-sm-2">{{ dropshipInput.store_address_detail }}</div>
                <div class="pt-1 text-caption text-body-sm-2">{{ dropshipInput.store_sub_district_name + ', ' + dropshipInput.store_district_name + ', ' + dropshipInput.store_city_name + ', ' + dropshipInput.store_province_name + ' ' + dropshipInput.store_sub_district_postal_code }}</div>
                <div class="pt-4 text-caption text-body-sm-2">Phone: {{ dropshipInput.store_phone | emptyData}}</div>
                <!-- <div class="pt-1 text-caption text-body-sm-2">Email: {{ dropshipInput.store_email | emptyData }}</div> -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="my-auto left-border text-body-2 d-none d-md-block">
            <v-card outlined class="pa-2">
              <v-row class="px-5 d-flex align-start">
                <v-col cols="5">
                  <v-row class="d-flex flex-row justify-space-between">
                    <v-col class="py-0">Status Toko</v-col>
                    <v-col class="py-0 primary--text font-weight-bold text-right">{{ detailStore.store_is_active }}</v-col>
                  </v-row>
                  <v-row class="d-flex flex-row justify-space-between pt-2">
                    <v-col cols="5" class="py-0">Bergabung</v-col>
                    <v-col cols="7" class="py-0 primary--text font-weight-bold text-right">{{ detailStore.store_input_datetime | tanggal}}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="6">
                  <v-row class="d-flex flex-row justify-space-between">
                    <v-col cols="5" class="py-0">Total Transaksi</v-col>
                    <v-col cols="7" class="py-0 primary--text font-weight-bold text-right">{{ detailStore.total_transaction }}</v-col>
                  </v-row>
                  <v-row class="d-flex flex-row justify-space-between pt-2">
                    <v-col class="py-0">Total Produk</v-col>
                    <v-col class="py-0 primary--text font-weight-bold text-right">{{ detailStore.total_product }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
const defaultInput = () => ({
  store_id:''
})
export default {
  data() {
    return {
      page: 1,
      limit: 8,
      params: [],
      sort: {},
      sortBy: '',
      sortDir: '',
      title: '',

      image_alert: false,
      isMobile: false,
      loadingProcess: false,
      listDropship: [],
			checkedMethod: '',
      dropshipRules: [
        v => !!v || 'Stokis tidak boleh kosong',
      ],
      dropshipInput: defaultInput(),
      detailStore: null
    }
  },

  computed: {
    ...mapState('productSeller', ['responseError']),
    ...mapState('partnersSeller', ['store']),
    ...mapState('authSeller', ['isAuth', 'sellerData']),
  },

  methods: {
    ...mapActions('partnersSeller', ['getStorePartnership', 'requestPartnership']),

    async getStoreDetail(slug) {
			await this.$http
				.get(`/store/detail-store/${slug}`, {
				})
				.then((res) => {
					const data = res.data.data
					this.detailStore = data
          // if (data) this.dropshipInput.store_image = data.store_image
          // console.log('detail store', this.detailStore)
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

    async getStorePartnerships() {
      // this.listDropship = Object.values(this.store.lists);
      
      await this.getStorePartnership(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
      this.listDropship = await this.store.lists.results
      // console.log('dropship', this.listDropship)

      if (this.dropshipInput.store_slug) this.getStoreDetail(this.dropshipInput.store_slug)
      this.loading = false
    },

    async save() {
      if (this.$refs.formAddDropship.validate()) {
        let params = {
          store_id: this.dropshipInput.store_id
        }

        this.requestPartnership(params).then( () => {
          this.$router.push('/seller/list-dropship')
        }).catch(() => {
          this.loadingProcess = false
        })
      }
    },
    cancelForm() {
      this.$router.push('/seller/list-dropship')
    },
  },
  async created() {
    this.$store.dispatch('setPageTitle', `Tambah Dropship`);
    this.getStorePartnerships()
  },
}
</script>

<style lang="scss" scoped>
  .product-img {
    border: 2px solid green;
    border-radius: 4px;

    &.emptyImg {
      border: 2px solid #ddd;
    }
  }
  .product-img {
    position: relative;
    .close-btn {
      position: absolute;
      top: -15px;
      right: -15px;
      height: 28px;
      width: 28px;
    }
  }
</style>